<template>
  <span>{{ displayValue }}</span>
</template>

<script>
export default {
  name: 'AbbreviatedNumber',
  props: {
    value: {
      type: Number,
      required: true
    },
    decimals: {
      type: Number,
      default: 1
    },
    minToAbbreviate: {
      type: Number,
      default: 9999
    }
  },
  computed: {
    displayValue() {
      if (Math.abs(this.value) < this.minToAbbreviate) {
        //return this.value.toLocaleString(); // Add commas
        return this.value.toString();
      }

      const suffixes = ['', 'k', 'M', 'B', 'T'];
      const tier = Math.floor(Math.log10(Math.abs(this.value)) / 3);
      const suffix = suffixes[tier] || '';
      const scale = Math.pow(10, tier * 3);
      const scaled = this.value / scale;

      return scaled.toFixed(this.decimals).replace(/\.0+$/, '') + suffix;
    }
  }
};
</script>

